export enum GlobalText {
	RoleHeader = "5BDDFB42-3F8F-4B0F-8872-ACAE84C6C4CB",
	LabelParticipant = "958F0491-E13B-4553-820C-2EEF5CC98EE9",
	LabelFacilitator = "9C0730E1-7637-4422-98AD-4E68B975A51F",
}
